import { gql } from "@apollo/client";

const GET_TEACHER_LEVELS = gql`
  query GetTeacherLevels($teacherId: ID!) {
    teacherLevels(teacherId: $teacherId) {
      id
      title
    }
  }
`;

export default GET_TEACHER_LEVELS;
